/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Template_Col_TemplateInputs */

const en_analytics_template_col_template = /** @type {(inputs: Analytics_Template_Col_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template`)
};

const de_analytics_template_col_template = /** @type {(inputs: Analytics_Template_Col_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlage`)
};

const fr_analytics_template_col_template = /** @type {(inputs: Analytics_Template_Col_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèle`)
};

const es_analytics_template_col_template = /** @type {(inputs: Analytics_Template_Col_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantilla`)
};

const it_analytics_template_col_template = /** @type {(inputs: Analytics_Template_Col_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modello`)
};

const nl_analytics_template_col_template = /** @type {(inputs: Analytics_Template_Col_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjabloon`)
};

const pl_analytics_template_col_template = /** @type {(inputs: Analytics_Template_Col_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szablon`)
};

const fi_analytics_template_col_template = /** @type {(inputs: Analytics_Template_Col_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Malli`)
};

const da_analytics_template_col_template = /** @type {(inputs: Analytics_Template_Col_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skabelon`)
};

const sv_analytics_template_col_template = /** @type {(inputs: Analytics_Template_Col_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mall`)
};

/**
* | output |
* | --- |
* | "Template" |
*
* @param {Analytics_Template_Col_TemplateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_template_col_template = /** @type {((inputs?: Analytics_Template_Col_TemplateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Template_Col_TemplateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_template_col_template(inputs)
	if (locale === "fr") return fr_analytics_template_col_template(inputs)
	if (locale === "es") return es_analytics_template_col_template(inputs)
	if (locale === "it") return it_analytics_template_col_template(inputs)
	if (locale === "nl") return nl_analytics_template_col_template(inputs)
	if (locale === "pl") return pl_analytics_template_col_template(inputs)
	if (locale === "fi") return fi_analytics_template_col_template(inputs)
	if (locale === "da") return da_analytics_template_col_template(inputs)
	if (locale === "sv") return sv_analytics_template_col_template(inputs)
	return en_analytics_template_col_template(inputs)
});